import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environment';
import { TicketIdWithCommunity } from '../models/ticket-id-with-community.model';
import { OutlookTicketModel } from '../models/outlook-ticket.model';

@Injectable({
    providedIn: 'root',
})
export class TicketService {
    constructor(private httpClient: HttpClient) {}

    getTicketsByItemId(itemId: string): Observable<TicketIdWithCommunity[]> {
        return this.httpClient.post<TicketIdWithCommunity[]>(
            environment.apiInboxUrl + 'tickets/Outlook/search',
            itemId,
        );
    }

    send(ticket: OutlookTicketModel, community: string): Observable<number> {
        return this.httpClient.post<number>(environment.apiInboxUrl + 'tickets/Outlook', ticket, {
            headers: new HttpHeaders({
                Community: community,
                Accept: 'application/json',
            }),
        });
    }
}
